export const initialEnvironment = {
  data: {
    brandName: "Nathan",
    brandNameAsCertification: false,
    brandLogo: "/ng1/www/img/logo-nathan.png",
    brandLogoLoading: "/ng1/www/img/logo-nathan.png",
    brandLogoLoadingHeight: 100,
    brandLogoSmall: "/ng1/www/img/logo-nathan-small.png",
    langForExercises: "en",
    goBackOnExercises: true,
    autoHideconsigne: true,
    autoplay: {
      initialValue: true,
      show: true,
    }
  }
}
